import { Actors as A, Tenants as T } from '@mntn/auth-types'
import { ErrorSchema as E } from '@mntn/result'
import { IDSchema } from '@mntn/zod'
import { z } from 'zod'

export const ProgramRatingResponseSchema = z.object({
  programRatingId: z.number().int().positive(),
  name: z.string(),
  programFormatId: IDSchema.positive('Please select a program format'),
})

const GetProgramRatingsResponseBodySchema = z.object({
  data: z.array(ProgramRatingResponseSchema),
})

const GetProgramRatingsSuccessResponseSchema = z
  .object({
    ok: z.literal(true),
    data: z.array(ProgramRatingResponseSchema),
  })
  .transform(({ data }) => ({ data }))
  .pipe(GetProgramRatingsResponseBodySchema)

export const GetProgramRatingsResponseSchema = {
  200: GetProgramRatingsSuccessResponseSchema,
  500: E('PROGRAM_RATINGS_QUERY_DB_ERROR'),
}

export const GetProgramRatingsRequestSchema = z.object({
  principal: T.KindSchema(['advertiser', 'publisher']).and(A.UserSchema),
})
